module.exports = __webpack_public_path__ + "img/down_orange_3_arrow.afcc2dba.svg";